<template>
  <div>
    <div class="d-aligncnter">
      <img src="@/assets/img/sportteam/chart-line.svg" class="title-img" />
      <span class="ml-8">月参训对比</span>
    </div>
    <div class="mt-16">
      <div class="echarts">
        <div
          id="bottomChart"
          style="width: 1860px; margin: 0 auto; height: 360px"
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: ['monthRate'],
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      bottomOption: {},
      sonData: [],
    }
  },
  watch: {
    monthRate: {
      handler: function () {
        this.sonData = this.monthRate
        this.initBarChart()
      },
      deep: true,
    },
  },
  mounted() {
    this.sonData = this.monthRate
    this.initBarChart()
  },
  methods: {
    initBarChart() {
      let data = this.sonData.teams
      let numList = this.sonData.rates
      let month = this.sonData.month
      var myChart = this.$echarts.init(document.getElementById('bottomChart'))
      this.bottomOption = {
        color: [
          '#FFB612',
          '#E5605A',
          '#009AFE',
          '#F97423',
          '#334FAA',
          '#A947F9',
          '#6D5FC7',
          '#FF59A9',
          '#12FFC6',
          '#FAFF12',
          '#EB8883',
          '#C98CFB',
          '#FFDA88',
          '#DE3831',
          '#B3E1FF',
          '#007A4D',
          '#B3FF37',
        ],
        title: {
          //   text: 'Stacked Line',
        },
        // tooltip: {
        //   trigger: 'axis',
        // },
        legend: {
          data: data,
          textStyle: {
            color: '#fff',
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            // saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: month,
        },
        yAxis: {
          type: 'value',
          axisLabel: { formatter: '{value} %' },
        },
        series: [
          //   {
          //     name: data[0],
          //     smooth: 0.4,
          //     type: 'line',
          //     stack: 'Total',
          //     symbol: 'none',
          //     data: [
          //       120, 132, 101, 134, 90, 230, 210, 120, 132, 101, 134, 90, 230,
          //     ],
          //   },
        ],
      }
      for (let i = 0; i < data.length; i++) {
        let each = {
          name: data[i],
          smooth: 0.4,
          type: 'line',
          //   stack: 'Total',
          symbol: 'none',
          data: numList[i],
        }
        this.bottomOption.series.push(each)
      }
      myChart.setOption(this.bottomOption)
    },
  },
}
</script>
<style lang="scss" scoped>
.mt-16 {
  margin-top: 16px;
}
.ml-8 {
  margin-left: 8px;
}
.echarts {
  margin-top: -32px;
}
</style>
